export class TipoOsParamModel {
  codigoMicroarea: String = '';
  apenasTipoOsEmergencial: Boolean = false;
  paginaAtual: number;
}
